import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";
import logo from "assets/images/hcm2-logo.png";
import classNames from "classnames";
import { commonConstants } from "constants/index";
import { commonHooks } from "hooks";
import { IRoute } from "models";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const { Sider, Footer } = Layout;
const { SubMenu } = Menu;
const { APP_TITLE, TABLET_WIDTH } = commonConstants;
const { useAppMenu, useWindowDimensions } = commonHooks;

interface AppSiderProps {
  filteredNavigation: IRoute[];
}

let autoCollapse = true;

const AppSider: React.FC<AppSiderProps> = (props) => {
  // Get selectedKey, openKey from route & pathname
  const { filteredNavigation } = props;

  const { selectedKey, openKey } = useAppMenu(filteredNavigation);
  const { width } = useWindowDimensions();
  const [collapsed, setCollapsed] = useState(false);

  const toggle = () => {
    autoCollapse = false;
    setCollapsed((collapsed) => !collapsed);
  };

  useEffect(() => {
    if (autoCollapse) {
      setCollapsed(width <= TABLET_WIDTH);
    }
  }, [width]);

  return (
    <Sider
      className={classNames({
        "app-sider": true,
        collapsed: collapsed,
      })}
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={272}
      collapsedWidth={80}
    >
      {collapsed ? (
        <MenuUnfoldOutlined data-testid="menu-expand-icon" className="app-icon app-trigger" onClick={toggle} />
      ) : (
        <MenuFoldOutlined data-testid="menu-collapse-icon" className="app-icon app-trigger" onClick={toggle} />
      )}

      <div className="app-logo">
        <Link to="/">
          <img src={logo} alt="logo" />
        </Link>
      </div>

      <Menu className="app-menu" theme="dark" mode="inline" defaultOpenKeys={[openKey]} selectedKeys={[selectedKey]}>
        {filteredNavigation.map((item) => {
          if (!item.icon) return null;
          if (!item.children) {
            return (
              <Menu.Item key={item.path}>
                {item.redirectOutside ? (
                  <a href={item.path}>
                    <item.icon className="app-icon" />
                    <span>{item.name}</span>
                  </a>
                ) : (
                  <Link to={item.path}>
                    <item.icon className="app-icon" />
                    <span>{item.name}</span>
                  </Link>
                )}
              </Menu.Item>
            );
          } else {
            const { children } = item;
            const childs = filteredNavigation.filter((child) => children.includes(child.path) && !child.children);
            return (
              <SubMenu
                key={item.path}
                title={
                  <span>
                    <item.icon className="app-icon" />
                    <span>{item.name}</span>
                  </span>
                }
              >
                {childs.map((child) => {
                  return (
                    <Menu.Item key={child.path}>
                      {child.redirectOutside ? (
                        <a href={child.path}>{child.name}</a>
                      ) : (
                        <Link to={child.path}>{child.name}</Link>
                      )}
                    </Menu.Item>
                  );
                })}
              </SubMenu>
            );
          }
        })}
      </Menu>

      {!collapsed && (
        <Footer className="app-footer">
          {APP_TITLE} © {import.meta.env.VITE_APP_VERSION}
        </Footer>
      )}
    </Sider>
  );
};

export default AppSider;
